module.exports = __webpack_public_path__ + "img/fangjia.46ac8c09.png";